import { render, staticRenderFns } from "./filter-button.component.vue?vue&type=template&id=73bf7dec&scoped=true&"
import script from "./filter-button.component.vue?vue&type=script&lang=ts&"
export * from "./filter-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./filter-button.component.vue?vue&type=style&index=0&id=73bf7dec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf7dec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
